<template>
  <div id="weather-point">
    <VuePerfectScrollbar
      class="scroll-area"
      :settings="scrollSettings"
    >
      <vs-row vs-type="flex" class="scroll-header pt-4 pb-2">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="5"
        >
          <vx-tooltip :color="AISEA_COLOR.GRAY_BLACK" text="地図上の右クリックで最大10個までポイントを追加できます">
            <span v-if="localPoints.length === 0" class="aisea-text-14-400-white">ポイント登録なし</span>
            <span v-else class="aisea-text-14-400-white">{{ localPoints.length }}/10</span>
          </vx-tooltip>
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="7"
        >
        </vs-col>
      </vs-row>
      <vs-divider v-if="localPoints.length !== 0" class="pb-2 m-0 scroll-separator" :color="AISEA_COLOR.GRAY"/>

      <vs-row v-for="point in localPoints"
              :key="point.pointId" vs-type="flex" class="mt-4">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="1"
        >
          <img :src="pointIcon">
        </vs-col>
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-14-400-white" @click="jumpToPoint(point.pointId)">{{ point.pointName }}</span>
        </vs-col>
      </vs-row>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

// Mixins
import {ColorMixin} from "@/mixins";

// Store
const {
  mapMutations: mapMutationsOfLiveMap,
  mapState: mapStateOfLiveMap
} = createNamespacedHelpers("liveMap");

export default {
  mixins: [ColorMixin],
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      pointIcon: require("@/assets/images/weather/offing_wave_point.svg"),
      scrollSettings: {
        maxScrollbarLength: 20,
        wheelSpeed: 0.6
      },
      localPoints: [],
    };
  },
  watch: {
    offingWavePoints(newPoints) {
      if (newPoints.length > this.localPoints.length && this.localPoints.length === 0) {
        this.localPoints.push(...newPoints)
        return
      }

      this.localPoints.splice(0, this.localPoints.length)

      if (newPoints.length === 0) return

      if (newPoints.length === this.localPoints.length) {
        newPoints.forEach((newPoint) => {
          let index = this.localPoints.findIndex((localPoint) => localPoint.pointId === newPoint.pointId);
          if (index !== -1) {
            this.localPoints.splice(index, 1, newPoint);
          }
        });
        return
      }

      if (newPoints.length < this.localPoints.length) {
        this.localPoints.splice(0, this.localPoints.length)
        newPoints.forEach((newPoint) => {
          this.localPoints.push(newPoint);
        });
        return
      }

      this.localPoints.forEach(localPoint => {
        let index = newPoints.findIndex((newPoint) => newPoint.pointId === localPoint.pointId);
        if (index === -1) {
          let i = this.localPoints.findIndex((point) => point.pointId === localPoint.pointId);
          this.localPoints.splice(i, 1);
        }
      })

      newPoints.forEach((newPoint) => {
        if (this.localPoints.length !== 0) {
          let index = this.localPoints.findIndex((localPoint) => localPoint.pointId === newPoint.pointId);
          if (index === -1) {
            this.localPoints.push(newPoint);
          }
        } else {
          this.localPoints.push(newPoint);
        }
      });

    },
  },
  computed: {
    ...mapStateOfLiveMap({offingWavePoints: state => state.offingWavePoints}
    ),
  },
  methods: {
    jumpToPoint(id) {
      let pointInfo = this.localPoints.find(v => v.pointId === id)
      let options = {
        center: pointInfo.coordinate,
        zoom: 8,
      }
      this.SET_JUMP_TO_MAP(options)
    },
    ...mapMutationsOfLiveMap([
      "SET_JUMP_TO_MAP",
    ]),
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#weather-point {
  .scroll-area {
    max-height: 20vh;

    .scroll-header {
      top: 0px;
      position: sticky;
      background-color: $aisea-blue-gray;
    }

    .scroll-separator {
      top: 42px;
      position: sticky;
    }

    &:not(.ps) {
      overflow-y: auto;
    }
  }
}

</style>
